import { useFormAddressModel } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/hooks/use-address";

import { useProductRoomI18nFormModelContext } from "../../../../_context";

export const useRoomI18nAddress = () => {
	const { viewModel, onSetViewModel } = useProductRoomI18nFormModelContext();
	const { address, lang } = viewModel;

	return {
		...useFormAddressModel({ address, onSetViewModel, lang }),
	};
};
